import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';

import { Subject } from 'rxjs';
import { ReportProvider } from 'src/app/providers';
import { saveAs } from 'file-saver';
import { ToasterService } from 'src/app/services';
import { AlertDialogComponent } from 'src/app/components';

@Component({
  selector: 'app-ist-excel-import',
  templateUrl: './ist-excel-import.component.html',
  styleUrls: ['./ist-excel-import.component.scss']
})
export class IstExcelImportComponent {
  subject: Subject<boolean>;
  versionId: string = '';

  public files: NgxFileDropEntry[] = [];


  constructor(public bsModalRef: BsModalRef,
    private reportProvider: ReportProvider,
    private toastr: ToasterService,
    private modalService: BsModalService) { }

  confirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  public dropped(files: NgxFileDropEntry[]) {
    const droppedFile = files[0];
    // Is it a file?
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        var allowedExtensions = /(\.xlsx|\.xls|\.csv)$/i;
        if (allowedExtensions.exec(file.name)) {
          this.toastr.info('Please wait a moment!');

          // You could upload it like this:
          const formData = new FormData();
          formData.append('file', file);

          this.reportProvider.excelImportIS(this.versionId, formData).subscribe(resp => {
            if (resp.success) {
              this.toastr.success('Upload successfully!');
              this.confirm();
            } else {
              // There is an Error Importing from Excel. Please check your data and try again,
              this.modalService.show(AlertDialogComponent, Object.assign({
                initialState: {
                  message: 'There is an Error Importing from Excel. Please check your data and try again.'
                }
              }, { class: 'modal-sm modal-dialog-centered' }));
            }
          }, err => {
            // Error Handling
          });
        } else {
          this.toastr.error('Please drop/select valid file!');
        }
      });
    } else {
      // It was a directory (empty directories are added, otherwise only files)
      // const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
    }
  }

  public fileOver(event) {
    // blank
  }

  public fileLeave(event) {
    // blank
  }

  downloadSampleFile() {
    this.reportProvider.downloadIsTemplate(this.versionId)
      .subscribe(
        response => {
          this.saveToFileSystem(response);
        }, error => {
          console.error(error);
        });
  }

  private saveToFileSystem(response) {
    const blob = new Blob([response], { type: 'text/xlsx' });
    saveAs(blob, 'Valzy_Import_Template.xlsx');
  }

}
